import identityApiClient from './identity-api-client'

export interface AssignOwnerToTenantRequest {
  email: string
  loginName: string
  tenantCode: string
}

export interface AssignOwnerToTenantResponse {
  loginId: string
  email: string
  loginName: string
  tenantCode: string
}

/**
 * Assign an owner to a tenant by creating a login for them
 * This creates a user account in the Identity service for the specified tenant
 */
export async function assignOwnerToTenant(request: AssignOwnerToTenantRequest): Promise<AssignOwnerToTenantResponse> {
  const response = await identityApiClient.post<AssignOwnerToTenantResponse>('/api/login', request)
  return response.data
}
